import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

import { StudyHistoryComponent } from './study-history.component';

@NgModule({
  declarations: [StudyHistoryComponent],
  exports: [StudyHistoryComponent],
  imports: [CommonModule, MatCardModule],
})
export class StudyHistoryModule {}
